<template>
  <v-container class="text-center">
    <v-data-table
      :headers="headers"
      :items-per-page="items.length"
      :items="items"
      :hide-default-footer="true"
      item-key="id"
      disable-sort
    >
      <template v-slot:top>
        <div class="mt-2 mb-2">
          <h1>Barchasi: {{ result.score }}</h1>

          <p>
            Boshlanish vaqti: {{ result.startedTime | moment("LLL") }}
            <br />
            Tugatgan vaqti: {{ result.finishedTime | moment("LLL") }}
          </p>
          <v-spacer>
            <v-btn @click="$router.push('/pages/user')" color="primary">Profilega qaytish</v-btn>
          </v-spacer>
        </div>
      </template>
      <template v-slot:item.index="{ item }">
        <b>{{ item.index + 1 }}</b>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
window.onbeforeunload = function() {
  return "Siz chiqib ketishni xohlaysizmi?";
};
import resultService from "../../service/Result.service";
import historyService from "../../service/ResultHistory.service";
export default {
  name: "ResultHistory",
  data() {
    return {
      result: {},
      histories: [],
      jwt: "",
      headers: [
        {
          text: "Index",
          value: "index",
          width: "10%",
          divider: true,
          align: "center",
        },
        {
          text: "Savol",
          align: "start",
          value: "quiz.question",
          width: "50%",
          divider: true,
        },
        {
          text: "Javob",
          align: "center",
          value: "selectedAnswerContent",
          width: "40%",
          divider: true,
        },
      ],
    };
  },
  computed: {
    items() {
      return this.histories;
    },
  },
  created() {
    this.initial();
  },
  methods: {
    initial() {
      this.jwt = this.$store.getters.jwt;
      resultService
        .getOne(this.$route.params.id, this.jwt)
        .then(res => {
          this.result = res.data;
          historyService
            .migrate(this.result.id, this.jwt)
            .then(res => {
              this.histories = res.data;
            })
            .catch(err => {
              alert(err);
            });
        });
    },
  },
};
</script>

<style scoped>
.history-card {
  width: 50rem;
  margin: 20px auto;
}
.answer {
  margin: 20px 15px;
}
</style>
